import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  class: "card card-stretch shadow",
  style: {"margin-bottom":"10px"}
}
const _hoisted_2 = {
  class: "card-body",
  style: {"padding":"15px"}
}
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Эхлэл")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Лавлагаа тайлан")
const _hoisted_5 = { class: "card shadow" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "card-title" }, [
    /*#__PURE__*/_createElementVNode("b", null, "Тоон мэдээлэл")
  ])
], -1)
const _hoisted_7 = { class: "card-body" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_9 = ["onClick"]
const _hoisted_10 = {
  key: 0,
  class: "spinner-border spinner-border-sm align-middle ms-2"
}
const _hoisted_11 = {
  key: 1,
  class: "fas fa-file-excel text-success fs-4"
}
const _hoisted_12 = ["data-kt-indicator"]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, [
  /*#__PURE__*/_createTextVNode(" Нийт хандалт  "),
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-file-excel text-success fs-6" })
], -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Түр хүлээнэ үү... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1)
const _hoisted_15 = [
  _hoisted_13,
  _hoisted_14
]
const _hoisted_16 = ["data-kt-indicator"]
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, [
  /*#__PURE__*/_createTextVNode(" Хэрэглэгчээр  "),
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-file-excel text-success fs-6" })
], -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Түр хүлээнэ үү... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1)
const _hoisted_19 = [
  _hoisted_17,
  _hoisted_18
]
const _hoisted_20 = {
  style: {"margin-top":"0"},
  align: "center"
}
const _hoisted_21 = { class: "text-primary" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_breadcrumb_item = _resolveComponent("el-breadcrumb-item")!
  const _component_el_breadcrumb = _resolveComponent("el-breadcrumb")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_space = _resolveComponent("el-space")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_el_breadcrumb, { "separator-class": "el-icon-arrow-right" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_breadcrumb_item, { to: { path: '/' } }, {
              default: _withCtx(() => [
                _hoisted_3
              ]),
              _: 1
            }),
            _createVNode(_component_el_breadcrumb_item, null, {
              default: _withCtx(() => [
                _hoisted_4
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _hoisted_6,
      _createElementVNode("div", _hoisted_7, [
        true
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createVNode(_component_el_space, {
                size: "mini",
                class: "col-sm-2"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input_number, {
                    modelValue: _ctx.pageSize,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.pageSize) = $event)),
                    onChange: _ctx.handleChange,
                    min: 1,
                    max: 100,
                    size: "mini"
                  }, null, 8, ["modelValue", "onChange"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_space, {
                size: "mini",
                class: "col-sm-2"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    modelValue: _ctx.yearValue,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.yearValue) = $event)),
                    size: "mini",
                    placeholder: "-- Он сонгох --",
                    onChange: _cache[2] || (_cache[2] = ($event: any) => (
              _ctx.getInqRef(this.yearValue, this.monthValue, this.selectOrgVal)
            ))
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.year, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item.yearValue,
                          label: item.yearLabel,
                          value: item.yearValue
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_space, {
                size: "mini",
                class: "col-sm-2"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    modelValue: _ctx.monthValue,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.monthValue) = $event)),
                    size: "mini",
                    placeholder: "-- Сар сонгох --",
                    onChange: _cache[4] || (_cache[4] = ($event: any) => (
              _ctx.getInqRef(this.yearValue, this.monthValue, this.selectOrgVal)
            ))
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.months, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item.monthValue,
                          label: item.monthLabel,
                          value: item.monthValue
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }),
              (this.isu)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    true
                      ? (_openBlock(), _createBlock(_component_el_space, {
                          key: 0,
                          size: "mini",
                          class: "col-sm-2"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_select, {
                              modelValue: this.selectVal,
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((this.selectVal) = $event)),
                              placeholder: "--Сонгох--",
                              filterable: "",
                              size: "mini",
                              onChange: _cache[6] || (_cache[6] = ($event: any) => (
                  this.selectOrgVal =
                    this.selectVal === '07' ? '*' : this.selectOrgVal
                ))
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.statusType, (item) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: item.selectVal,
                                    label: item.selectLabel,
                                    value: item.selectVal
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (this.selectVal !== '07')
                      ? (_openBlock(), _createBlock(_component_el_space, {
                          key: 1,
                          size: "mini",
                          class: "col-sm-2"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_select, {
                              modelValue: this.selectOrgVal,
                              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((this.selectOrgVal) = $event)),
                              placeholder: "--Сонгох--",
                              filterable: "",
                              onChange: _cache[8] || (_cache[8] = ($event: any) => (
                  _ctx.getInqRef(this.yearValue, this.monthValue, this.selectOrgVal)
                )),
                              size: "mini"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_option, {
                                  value: "*",
                                  label: "Бүгд"
                                }),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredOrgList, (item) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: item.selectOrgVal,
                                    label: item.selectOrgLabel,
                                    value: item.selectOrgVal
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ], 64))
                : _createCommentVNode("", true),
              _createVNode(_component_el_space, {
                size: "mini",
                class: "col-sm-2"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: this.searchValue,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((this.searchValue) = $event)),
                    size: "mini",
                    placeholder: "Хайх утга аа оруулна уу...",
                    "prefix-icon": "el-icon-search"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ], 64))
          : _createCommentVNode("", true),
        _hoisted_8,
        true
          ? _withDirectives((_openBlock(), _createBlock(_component_el_table, {
              key: 1,
              data: 
            this.tableData
              .filter(
                data =>
                  !this.searchValue ||
                  data.searchfield.includes(this.searchValue.toLowerCase())
              )
              .slice(
                this.pageSize * this.page - this.pageSize,
                this.pageSize * this.page
              )
          ,
              border: "",
              size: "small",
              "element-loading-text": "Өгөгдөл татаж байна...",
              "empty-text": "Өгөгдөл байхгүй байна.",
              "cell-style": { textAlign: 'center' },
              "header-cell-style": { textAlign: 'center' },
              style: {"margin-top":"10px"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table_column, {
                  label: "№",
                  width: "50"
                }, {
                  default: _withCtx((scope) => [
                    _createTextVNode(_toDisplayString(scope.$index + 1), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  label: "Хэрэглэгчийн дугаар",
                  prop: "username",
                  sortable: ""
                }),
                _createVNode(_component_el_table_column, {
                  label: "Төлбөртэй лавлагаа",
                  width: "400"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_table_column, {
                      label: "Иргэн",
                      prop: "citizen_payable",
                      sortable: ""
                    }),
                    _createVNode(_component_el_table_column, {
                      label: "Хуулийн этгээд",
                      prop: "org_payable",
                      sortable: ""
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  label: "Чөлөөлөгдсөн лавлагаа",
                  width: "400"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_table_column, {
                      label: "Иргэн",
                      prop: "citizen_unpayable",
                      sortable: ""
                    }),
                    _createVNode(_component_el_table_column, {
                      label: "Хуулийн этгээд",
                      prop: "org_unpayable",
                      sortable: ""
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  label: "Нийт",
                  prop: "total",
                  sortable: ""
                }),
                _createVNode(_component_el_table_column, { label: "Дэлэгрэнгүй тайлан" }, {
                  default: _withCtx((scope) => [
                    _createElementVNode("span", {
                      class: "customized-link-span",
                      onClick: ($event: any) => (_ctx.getReport('inquiryHistoryByUser', scope.row.username))
                    }, [
                      (this.loadingButton === 'on')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_10))
                        : (_openBlock(), _createElementBlock("i", _hoisted_11))
                    ], 8, _hoisted_9)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["data"])), [
              [_directive_loading, this.dataLoading]
            ])
          : _createCommentVNode("", true),
        true
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              _createVNode(_component_el_row, { style: {"margin-top":"25px"} }, {
                default: _withCtx(() => [
                  _createElementVNode("button", {
                    class: "el-button el-button--default el-button--small is-plain",
                    onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.getReport('totalAccess', null))),
                    "data-kt-indicator": this.loadingButton
                  }, _hoisted_15, 8, _hoisted_12),
                  _createElementVNode("button", {
                    class: "el-button el-button--default el-button--small is-plain",
                    onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.getReport('inquiryAllUsers', null))),
                    "data-kt-indicator": this.loadingButton
                  }, _hoisted_19, 8, _hoisted_16)
                ]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("div", null, [
                  _createVNode(_component_el_pagination, {
                    background: "",
                    layout: "prev, pager, next",
                    onCurrentChange: _ctx.handleCurrentChange,
                    "page-size": _ctx.pageSize,
                    total: this.tableData.length
                  }, null, 8, ["onCurrentChange", "page-size", "total"])
                ]),
                _createElementVNode("div", _hoisted_21, " Бичлэгийн тоо: " + _toDisplayString(this.tableData.length), 1)
              ])
            ], 64))
          : _createCommentVNode("", true)
      ])
    ])
  ], 64))
}